var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              staticClass: "d-flex justify-content-between align-items-center",
            },
            [
              _c(
                "text-header",
                {
                  staticClass: "atmo-hash-jump-point",
                  attrs: { id: "atmo-protocol-completion" },
                },
                [_vm._v("Подведение итогов закупочной сессии")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.loading
        ? _c(
            "div",
            [
              _c("b-table", {
                staticClass: "table-atmo overflow-hidden mb-2",
                attrs: {
                  fields: _vm.fields,
                  items: _vm.proposals,
                  "show-empty": "",
                  small: "",
                  responsive: "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell(index)",
                      fn: function (data) {
                        return [_vm._v(" " + _vm._s(data.index + 1) + " ")]
                      },
                    },
                    {
                      key: "cell(status)",
                      fn: function (data) {
                        return [
                          _vm._v(" " + _vm._s(data.item.status.title) + " "),
                          data.item.is_my_proposal
                            ? _c("span", {
                                domProps: { textContent: _vm._s("(Моё)") },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "cell(created_at)",
                      fn: function (data) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$formatDateTime(data.item.created_at)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(supplier)",
                      fn: function (data) {
                        return [
                          data.item.id === _vm.selectedProposalId
                            ? _c("b-icon-award", {
                                staticStyle: { color: "var(--orange)" },
                                attrs: { title: "Выбран победителем" },
                              })
                            : _vm._e(),
                          _vm._v("  "),
                          _c(
                            "router-link",
                            {
                              staticClass: "atmo-button-link",
                              attrs: {
                                target: "_blank",
                                to: {
                                  name: "OrganizationShow",
                                  params: { id: data.item.supplier.id },
                                },
                              },
                            },
                            [_vm._v(_vm._s(data.item.supplier.name))]
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(rating)",
                      fn: function (data) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$formatPrice(data.item.supplier.rating)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(actions)",
                      fn: function (data) {
                        return [
                          _c("action-button-small", {
                            attrs: {
                              icon: "clipboard-check",
                              title: "Информация о подписи",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.showSign(false, data.item.signature)
                              },
                            },
                          }),
                          data.item.signature.poa_number &&
                          data.item.signature.poa_check_link
                            ? _c("action-button-small", {
                                staticClass: "ml-1",
                                attrs: {
                                  icon: "clipboard-plus",
                                  title: "Информация о МЧД",
                                  variant: "warning",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.showSign(
                                      false,
                                      data.item.signature
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                          _c("action-button-small", {
                            staticClass: "ml-1",
                            attrs: {
                              icon: "cloud-download",
                              title: "Скачать xml файл",
                              variant: "outline",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.downloadXml(
                                  data.item.signature.xml,
                                  false,
                                  `proposal_${data.item.id}`
                                )
                              },
                            },
                          }),
                          _c(
                            "b-button",
                            {
                              staticClass:
                                "btn-card-action btn-card-action-green text-uppercase ml-1",
                              staticStyle: {
                                height: "24px",
                                "padding-top": "5px !important",
                                "padding-bottom": "5px !important",
                              },
                              on: { click: data.toggleDetails },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  data.detailsShowing ? "Скрыть" : "Показать"
                                ) + " подробности"
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "row-details",
                      fn: function (data) {
                        return [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  data.item.status.id === "rejected"
                                    ? _c("text-row", {
                                        attrs: {
                                          label: "Причина отклонения",
                                          compact: "",
                                        },
                                        model: {
                                          value:
                                            data.item.proposal_details
                                              .decline_status_name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              data.item.proposal_details,
                                              "decline_status_name",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "data.item.proposal_details.decline_status_name",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "fs-14 my-1",
                                      attrs: {
                                        variant: "custom-outline-secondary",
                                        size: "sm",
                                        href:
                                          _vm.rnpCheckLink +
                                          data.item.supplier.inn,
                                        target: "_blank",
                                      },
                                    },
                                    [_vm._v("Проверить в РНП")]
                                  ),
                                  _c(
                                    "download-organization-analytics-report-button",
                                    {
                                      staticClass: "ml-2",
                                      attrs: {
                                        organization: data.item.supplier,
                                      },
                                    }
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "text-row-raw",
                                    {
                                      attrs: { label: "Контакты", compact: "" },
                                    },
                                    [
                                      _c(
                                        "ul",
                                        {
                                          staticClass:
                                            "fs-14 grey-color my-auto col-form-label",
                                        },
                                        [
                                          _c("li", [
                                            _vm._v("ФИО: "),
                                            _c("b", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  data.item.proposal_details
                                                    .contact_name
                                                ),
                                              },
                                            }),
                                          ]),
                                          _c("li", [
                                            _vm._v(" Телефон: "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "atmo-button-link",
                                                attrs: {
                                                  href: `tel:+${data.item.proposal_details.contacts.phone}`,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$parsePhone(
                                                      data.item.proposal_details
                                                        .contacts.phone
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("li", [
                                            _vm._v("Email: "),
                                            _c("a", {
                                              staticClass: "atmo-button-link",
                                              attrs: {
                                                href: `mailto:${data.item.proposal_details.contacts.email}`,
                                              },
                                              domProps: {
                                                textContent: _vm._s(
                                                  data.item.proposal_details
                                                    .contacts.email
                                                ),
                                              },
                                            }),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c("text-row-single-document", {
                                    attrs: {
                                      compact: "",
                                      label: "Карточка предприятия",
                                    },
                                    model: {
                                      value:
                                        data.item.proposal_details
                                          .organization_card,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          data.item.proposal_details,
                                          "organization_card",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data.item.proposal_details.organization_card",
                                    },
                                  }),
                                  _c(
                                    "text-row-raw",
                                    {
                                      attrs: {
                                        label:
                                          "Требования к участникам закупки",
                                        compact: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "ul",
                                        {
                                          staticClass:
                                            "fs-14 grey-color my-auto col-form-label",
                                        },
                                        [
                                          data.item.proposal_details
                                            .supplier_requirements_confirmed
                                            .supplier_reqs_a
                                            ? _c("li", [
                                                _c("i", {
                                                  staticClass:
                                                    "atmo-icon-checkbox",
                                                }),
                                                _vm._v(
                                                  " Поставщик подтвердил, что соответствует требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ. "
                                                ),
                                                _c(
                                                  "ul",
                                                  [
                                                    _c("li", [
                                                      _vm._v(
                                                        "Документы, подтверждающие соответствие требованиям:"
                                                      ),
                                                    ]),
                                                    _vm._l(
                                                      data.item.proposal_details
                                                        .supplier_requirements_confirmed
                                                        .supplier_required_documents,
                                                      function (
                                                        document,
                                                        index
                                                      ) {
                                                        return _c(
                                                          "li",
                                                          { key: index },
                                                          [
                                                            _c(
                                                              "ul",
                                                              {
                                                                staticClass:
                                                                  "ml-3",
                                                              },
                                                              [
                                                                _c("li", [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        `${
                                                                          index +
                                                                          1
                                                                        }. ${
                                                                          document.name
                                                                        } - `
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "fs-14 atmo-button-link",
                                                                      attrs: {
                                                                        href: _vm.$getAttachmentDownloadLink(
                                                                          document
                                                                            .storedDocument
                                                                            .id
                                                                        ),
                                                                        target:
                                                                          "_blank",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          document
                                                                            .storedDocument
                                                                            .name
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ])
                                            : _vm._e(),
                                          data.item.proposal_details
                                            .supplier_requirements_confirmed
                                            .supplier_reqs_b
                                            ? _c("li", [
                                                _c("i", {
                                                  staticClass:
                                                    "atmo-icon-checkbox",
                                                }),
                                                _vm._v(
                                                  " Поставщик подтвердил, что соответствует требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ. "
                                                ),
                                              ])
                                            : _vm._e(),
                                          data.item.proposal_details
                                            .supplier_requirements_confirmed
                                            .supplier_reqs_c
                                            ? _c("li", [
                                                _c("i", {
                                                  staticClass:
                                                    "atmo-icon-checkbox",
                                                }),
                                                _vm._v(
                                                  " Поставщик подтвердил, что соответствует требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ. "
                                                ),
                                              ])
                                            : _vm._e(),
                                          data.item.proposal_details
                                            .supplier_requirements_confirmed
                                            .supplier_reqs_sonko
                                            ? _c("li", [
                                                _c("i", {
                                                  staticClass:
                                                    "atmo-icon-checkbox",
                                                }),
                                                _vm._v(
                                                  " Поставщик подтвердил, что является "
                                                ),
                                                _c(
                                                  "abbr",
                                                  {
                                                    attrs: {
                                                      title:
                                                        "Социально ориентированная некоммерческая организация",
                                                    },
                                                  },
                                                  [_vm._v("СОНКО")]
                                                ),
                                                _vm._v("."),
                                              ])
                                            : _vm._e(),
                                          !!data.item.proposal_details
                                            .supplier_requirements_confirmed
                                            .additional_requirements &&
                                          data.item.proposal_details
                                            .supplier_requirements_confirmed
                                            .additional_requirements.length > 0
                                            ? _c("li", [
                                                _c("i", {
                                                  staticClass:
                                                    "atmo-icon-checkbox",
                                                }),
                                                _vm._v(
                                                  " Поставщик подтвердил соответствие дополнительным требованиям приложив следующие документы: "
                                                ),
                                                _c(
                                                  "ul",
                                                  _vm._l(
                                                    data.item.proposal_details
                                                      .supplier_requirements_confirmed
                                                      .additional_requirements,
                                                    function (
                                                      requirement,
                                                      index
                                                    ) {
                                                      return _c(
                                                        "li",
                                                        { key: index },
                                                        [
                                                          _c(
                                                            "ul",
                                                            {
                                                              staticClass:
                                                                "ml-3",
                                                            },
                                                            [
                                                              _c("li", [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      `${
                                                                        index +
                                                                        1
                                                                      }. ${
                                                                        requirement.description
                                                                      } (Причина: ${
                                                                        requirement.reason
                                                                      }) - `
                                                                    ) +
                                                                    " "
                                                                ),
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "fs-14 atmo-button-link",
                                                                    attrs: {
                                                                      href: _vm.$getAttachmentDownloadLink(
                                                                        requirement
                                                                          .attachment
                                                                          .id
                                                                      ),
                                                                      target:
                                                                        "_blank",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        requirement
                                                                          .attachment
                                                                          .name
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                                  data.item.proposal_details.commercial_proposal
                                    ? _c("text-row-single-document", {
                                        attrs: {
                                          compact: "",
                                          label: "Коммерческое предложение",
                                        },
                                        model: {
                                          value:
                                            data.item.proposal_details
                                              .commercial_proposal,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              data.item.proposal_details,
                                              "commercial_proposal",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "data.item.proposal_details.commercial_proposal",
                                        },
                                      })
                                    : _vm._e(),
                                  data.item.proposal_details.attachments
                                    .length > 0
                                    ? _c("text-row-documents", {
                                        attrs: {
                                          compact: "",
                                          label: "Дополнительные документы",
                                        },
                                        model: {
                                          value:
                                            data.item.proposal_details
                                              .attachments,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              data.item.proposal_details,
                                              "attachments",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "data.item.proposal_details.attachments",
                                        },
                                      })
                                    : _vm._e(),
                                  _c("text-row-proposal-specification-table", {
                                    attrs: {
                                      "without-vat":
                                        data.item.proposal_details.without_vat,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "header",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "fs-14 fw-600",
                                                  staticStyle: {
                                                    "padding-left": "5px",
                                                  },
                                                },
                                                [_vm._v("Спецификация:")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value:
                                        data.item.proposal_details.deliverables,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          data.item.proposal_details,
                                          "deliverables",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data.item.proposal_details.deliverables",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { staticClass: "d-flex" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "fs-14 my-1",
                                      attrs: {
                                        disabled:
                                          data.item.status.id !== "actual" ||
                                          data.item.id ===
                                            _vm.selectedProposalId,
                                        size: "sm",
                                        variant: "custom-green",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectWinner(data.item.id)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          data.item.id ===
                                            _vm.selectedProposalId
                                            ? "Выбран"
                                            : "Выбрать"
                                        ) + " победителем"
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "fl44-unknown-volume-reject-proposal-button",
                                    {
                                      staticClass: "ml-2",
                                      attrs: {
                                        purchase: _vm.purchase,
                                        proposal: data.item,
                                      },
                                      on: {
                                        refresh: function ($event) {
                                          return _vm.refresh(data.item.id)
                                        },
                                      },
                                    }
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "empty",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "w-100 text-center" }, [
                            _vm._v("Нет поданных предложений"),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2789021461
                ),
              }),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "d-flex" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "fs-14 my-1",
                          attrs: {
                            disabled: _vm.$v.$invalid,
                            size: "sm",
                            variant: "custom-green",
                          },
                          on: {
                            click: function ($event) {
                              _vm.isModalVisible = true
                            },
                          },
                        },
                        [_vm._v("Сформировать итоговый протокол")]
                      ),
                      _vm.$v.$invalid
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                            },
                            [
                              _vm._v(
                                "Необходимо выбрать победителя или отклонить все предложения"
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.signData.signature
                ? _c("show-sign-modal", {
                    attrs: {
                      signature: _vm.signData.signature,
                      "org-is-customer": _vm.signData.isCustomer,
                      show: _vm.showSignModal,
                    },
                    on: {
                      close: function ($event) {
                        _vm.showSignModal = false
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          ref: "cancel-modal",
          attrs: {
            "body-class": "pt-0",
            "header-class": "pb-1",
            centered: "",
            "hide-header-close": "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            title: "Уважаемый пользователь!",
          },
          model: {
            value: _vm.isModalVisible,
            callback: function ($$v) {
              _vm.isModalVisible = $$v
            },
            expression: "isModalVisible",
          },
        },
        [
          _c("p", { staticClass: "text-danger fw-600 fs-16 my-1" }, [
            _vm._v("Обращаем Ваше внимание, что данное действие необратимо."),
          ]),
          _c("p", { staticClass: "text-danger fw-600 fs-16 my-1" }, [
            _vm._v(
              'Нажимая кнопку "Сформировать итоговый протокол" Вы подтверждаете' +
                _vm._s(
                  _vm.hasNoProposals
                    ? ", что данная закупка не состоялась"
                    : (_vm.hasRejectedAllProposals
                        ? " отклонение всех предложений"
                        : " выбор поставщика") + " для данной закупки"
                ) +
                "."
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "w-100 text-right",
              attrs: { slot: "modal-footer" },
              slot: "modal-footer",
            },
            [
              _c(
                "b-overlay",
                {
                  staticClass: "d-inline-block",
                  attrs: {
                    show: _vm.isDataSending,
                    opacity: "0.6",
                    rounded: "",
                    "spinner-small": "",
                    "spinner-variant": "primary",
                  },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "text-uppercase mr-2",
                      attrs: { variant: "custom-outline-secondary" },
                      on: {
                        click: function ($event) {
                          _vm.isModalVisible = false
                        },
                      },
                    },
                    [_vm._v("Отменить")]
                  ),
                ],
                1
              ),
              _c(
                "b-overlay",
                {
                  staticClass: "d-inline-block",
                  attrs: {
                    show: _vm.isDataSending,
                    opacity: "0.6",
                    rounded: "",
                    "spinner-small": "",
                    "spinner-variant": "primary",
                  },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "text-uppercase",
                      attrs: { variant: "custom-green" },
                      on: { click: _vm.storeProtocol },
                    },
                    [_vm._v("Сформировать итоговый протокол")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }